import React from "react";
import {
  GetEquityReactivationClientValidation,
  updateAccReactStatus,
} from "../../../service/serviceRequest/srApiService";
import { AddressModification } from "../addressModification/addressModification";
import { Bank } from "../bankDetails/bankModification";
import { CKYCUpdate } from "../CKYC/ckycUpdate";
import { VerficationStage } from "../verficationStage/verficationStage";
import { ProfileForm } from "./profileForm";
import { asyncGetServiceRequest } from "../../../service/postLogin/clientProfileAPIService";
import Loader from "../../../generic/loader";
import { getAccData, getUserID } from "../../../service/login/loginService";
import { AccountPayment } from "../accPayment/accPayment";
import { useQuery } from "../../../service/urlHelper";
import { config } from "../../../../config/domain";

const flow = [
  {
    RequestType: "FATCA Declaration",
    Stage: 1,
    type: 1,
  },
  {
    RequestType: "Income Declaration",
    Stage: 1,
    type: 2,
  },
  {
    RequestType: "Email and Phone Update",
    Stage: 1,
    type: 3,
  },
  {
    RequestType: "Change of Address",
    Stage: 2,
    type: 4,
  },
  // {
  //   RequestType: "Bank Modification",
  //   Stage: 3,
  //   type: 5,
  // },
  {
    RequestType: "CKYC Update",
    Stage: 4,
    type: 6,
  },
  {
    RequestType: "E-sign",
    Stage: 5,
    type: 7,
  },
];

// const consetflow = [
//   {
//     RequestType: "Change of Address",
//     Stage: 2,
//   },
//   {
//     RequestType: "CKYC Update",
//     Stage: 4,
//   },
//   {
//     RequestType: "E-sign",
//     Stage: 5,
//   },
// ];

class AccReactivateCont extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      //  currentStage: 1,
      userData: {},
      srId: 0,
      childSrList: [],
      currentFlow: [],
      //loader: true,
    };
  }
 
  nextStage = async (familyDeclReq?: any) => {
    this.props.setLoader(true);
    let nextFlow = this.state.currentFlow;
    nextFlow = nextFlow.filter(
      (flow: any) => flow.Stage !== this.props.stage.currentStage
    );
    const sr = JSON.parse(
      localStorage.getItem("accReactParentDetails") || "{}"
    );

    if (sr && sr.dormant_type !== "1") {
      this.props.setLoader(false);
        if (sr.dormant_type.includes("6")) {
          let accReactSrList: any = await asyncGetServiceRequest(
            sr.RequestId
              ? sr.RequestId
              : Number(localStorage.getItem("accReactParentId"))
          );
          console.log("accReactSrList", accReactSrList);
          console.log("accReactSrList", accReactSrList.length);

          if (accReactSrList.length > 0) {
            let addressSR = accReactSrList.filter((childSr: any) => {
              return childSr.RequestType === "Change of Address";
            });

            if (addressSR.length > 0 && addressSR[0].is_digilocker_flow) {
              nextFlow = [];
            }
            if (nextFlow.length === 0)
              nextFlow.push(flow.find((list) => list.type === 7));
          }
        } else nextFlow.push(flow.find((list) => list.type === 7));
    }
    nextFlow.sort((a: any, b: any) => a.Stage - b.Stage);
    this.setState({ currentFlow: nextFlow });
    this.props.stage.setCurrentStage(nextFlow[0].Stage);
    this.props.setLoader(false);
  };
  redirect = (url: string) => {
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      // If url is absolute
      window.location.href = url;
    }
  };

  async componentDidMount() {
    try {

      let personalDetails: any = window.localStorage.getItem("personalDetails");
      let userIdDet = JSON.parse(personalDetails);
      if (userIdDet && userIdDet.accCode !== getUserID())
        localStorage.removeItem("personalDetails");

      this.props.srDropDown(true);
      const userData = await GetEquityReactivationClientValidation();
      this.setState({ userData: userData.result[0] });
      const serviceList = await asyncGetServiceRequest();
      const consentList = getAccData("cnsntLst")
        ? getAccData("cnsntLst")
        : JSON.parse(localStorage.getItem("cnsntLst") || "[]");

      const sr = serviceList.filter(
        (srReq: any) =>
          srReq.RequestType === "Equity Dormant Reactivation" &&
          [
            "Draft Saved",
            "Approved",
            "Submitted",
            "AssignedtoHO",
            "InProcess",
            "PendingForEsign",
            "EsignVerified",
            "EsignSubmitted",
            "AssignedforEsignQC",
            "EsignVerified",
            "PushToTarget",
            "MemorandumPaymentPending",
          ].includes(srReq.RequestStatus)
      )[0];

      let accReactParentDetails: any;
      if (!sr) {
        accReactParentDetails = localStorage.getItem("accReactParentDetails");
        accReactParentDetails = JSON.parse(accReactParentDetails);
        if (!accReactParentDetails.RequestId) {
          this.props.onSubmit("createRequestApiError", {
            content: accReactParentDetails.Message,
            headerText: "New Service Request",
          });
          return;
        }

        const srId: string = accReactParentDetails.RequestId
          ? accReactParentDetails.RequestId
          : accReactParentDetails.Id;
        localStorage.setItem("accReactParentId", srId);
      } else {
        accReactParentDetails = sr;
      }
      localStorage.setItem(
        "accReactParentDetails",
        JSON.stringify(accReactParentDetails)
      );
      this.setState({
        srId: accReactParentDetails.RequestId
          ? accReactParentDetails.RequestId
          : localStorage.getItem("accReactParentId"),
      });
      // const accReactSrList: any =[];
      const accReactSrList: any = await asyncGetServiceRequest(
        (sr && sr.RequestId)
          ? sr.RequestId
          : Number(localStorage.getItem("accReactParentId"))
      );
      const consentFlow: any = [];
      if (accReactSrList.length > 0) {
        if (
          (accReactParentDetails.hasOwnProperty("RequestStatus") &&
            accReactParentDetails.RequestStatus === "Draft Saved") ||
          window.location.href.includes("rejected")
        ) {
          let setFlow: any;

          if (accReactParentDetails.dormant_type === "1") {
            setFlow = flow;
            accReactSrList.map((res: any) => {
              if (window.location.href.includes("rejected")) {
                if (res.RequestStatus !== "Rejected - Resubmit") {
                  if (
                    res.RequestType ===
                    flow[
                      flow.findIndex((f: any) => {
                        if (f) return f.type === 6;
                      })
                    ].RequestType
                  ) {
                    return;
                  }
                  const index = setFlow.findIndex((f: any) => {
                    if (f) return f.RequestType === res.RequestType;
                  });
                  delete setFlow[index];
                }
              } else {
                if (
                  res.RequestType ===
                  flow[
                    flow.findIndex((f: any) => {
                      if (f) return f.type === 6;
                    })
                  ].RequestType
                ) {
                  return;
                }
                const index = setFlow.findIndex((f: any) => {
                  if (f) return f.RequestType === res.RequestType;
                });
                delete setFlow[index];
              }
            });
            let profileList = setFlow.filter((f: any) => {
              if (f)
                return f.type === 1 && f.RequestType !== "FATCA Declaration";
            });
            if (profileList && profileList.length === 0) {
              setFlow.sort((a: any, b: any) => a.Stage - b.Stage);

              setFlow = setFlow.filter((f: any) => {
                if (f) return f.RequestType !== "FATCA Declaration";
              });
            }

            if (window.location.href.includes("rejected")) {
              if (
                !(
                  setFlow.filter((f: any) => f.type === 4)[0] ||
                  setFlow.filter((f: any) => f.type === 5)[0] ||
                  setFlow.filter((f: any) => f.type === 6)[0]
                )
              ) {
                const i = setFlow.findIndex((f: any) => {
                  if (f) return f.type === 6;
                });
                delete setFlow[i];
              }
              // removing address or bank if SR is not created
              setFlow.map((f: any, i: any) => {
                if (f.type === 4 || f.type === 5) {
                  const SR = accReactSrList.find(
                    (sr: any) => sr.RequestType === f.RequestType
                  );
                  if (!SR) {
                    delete setFlow[i];
                  }
                }
              });
            }
          } else if (accReactParentDetails.dormant_type !== "1") {
            consentList.map((consent: any) => {
              let index;
              switch (consent.name) {
                case "eqIncmDclr":
                  index = flow.findIndex((f: any) => {
                    if (f) return f.type === 2;
                  });
                  consentFlow.push(flow[index]);
                  break;
                case "emailMob":
                  index = flow.findIndex((f: any) => {
                    if (f) return f.type === 3;
                  });
                  consentFlow.push(flow[index]);
                  break;
                case "invAddress":
                  index = flow.findIndex((f: any) => {
                    if (f) return f.type === 4;
                  });
                  consentFlow.push(flow[index]);
                  break;
                default:
                  break;
              }
            });
            setFlow = consentFlow;
            accReactSrList.map((res: any) => {
              if (window.location.href.includes("rejected")) {
                if (res.RequestStatus !== "Rejected - Resubmit") {
                  const index = setFlow.findIndex((f: any) => {
                    if (f) return f.RequestType === res.RequestType;
                  });
                  delete setFlow[index];
                }
              } else {
                const index = setFlow.findIndex((f: any) => {
                  if (f) return f.RequestType === res.RequestType;
                });
                delete setFlow[index];
              }
            });
          }
          console.log(setFlow);
          setFlow.sort((a: any, b: any) => a.Stage - b.Stage);
          setFlow.filter((f: any) => f);
          this.props.stage.setCurrentStage(setFlow[0].Stage);
          this.setState({ currentFlow: setFlow, childSrList: accReactSrList });
        } else if (
          accReactParentDetails.hasOwnProperty("RequestStatus") &&
          ["Submitted", "Approved", "InProcess", "PendingForEsign"].includes(
            accReactParentDetails.RequestStatus
          )
        ) {
          this.setState({ childSrList: accReactSrList });
          this.props.stage.setCurrentStage(5);
          this.setState({ currentFlow: [flow.find((x) => x.Stage === 5)] });
        } else if (
          accReactParentDetails.hasOwnProperty("RequestStatus") &&
          (accReactParentDetails.RequestStatus === "MemorandumPaymentPending" ||
            accReactParentDetails.RequestStatus === "EsignVerified")
        ) {
          this.setState({ childSrList: accReactSrList });
          this.props.stage.setCurrentStage(6);
          this.setState({
            currentFlow: [
              {
                RequestType: "Memorandum Payment",
                Stage: 6,
                type: 8,
              },
            ],
          });
        } else {
          const urlSearchParams = new URLSearchParams(
            this.props.location.search
          );
          const params = Object.fromEntries(urlSearchParams.entries());
          this.redirect(
            params.source === "ajs"
              ? config.rootUrl + "clientarea/servicerequest"
              : config.root + "/clientarea/service-request"
          );
        }
      } else {
        if (accReactParentDetails.dormant_type !== "1" && consentList.length > 0) {
          consentList.map((consent: any) => {
            let index;
            switch (consent.name) {
              case "eqIncmDclr":
                index = flow.findIndex((f: any) => {
                  if (f) return f.type === 2;
                });
                consentFlow.push(flow[index]);
                break;
              case "emailMob":
                index = flow.findIndex((f: any) => {
                  if (f) return f.type === 3;
                });
                consentFlow.push(flow[index]);
                break;
              case "invAddress":
                index = flow.findIndex((f: any) => {
                  if (f) return f.type === 4;
                });
                consentFlow.push(flow[index]);
                break;
              default:
                break;
            }
          });
          const addressIndex = consentFlow.findIndex((f: any) => {
            if (f) return f.type === 4;
          });
          const bankIndex = consentFlow.findIndex((f: any) => {
            if (f) return f.type === 5;
          });

          if (addressIndex >= 0 || bankIndex >= 0) {
            consentFlow.push(
              flow[
                flow.findIndex((f: any) => {
                  if (f) return f.type === 6;
                })
              ]
            );
            consentFlow.push(
              flow[
                flow.findIndex((f: any) => {
                  if (f) return f.type === 7;
                })
              ]
            );
          }
          consentFlow.sort((a: any, b: any) => a.Stage - b.Stage);
          this.props.stage.setCurrentStage(consentFlow[0].Stage);
        }
        this.setState({
          currentFlow:
            accReactParentDetails.dormant_type !== "1" ? consentFlow : flow,
          childSrList: accReactSrList,
        });
      }
      this.props.setLoader(false);
    } catch (err) {
      this.props.setLoader(false);
      this.props.onSubmit("createRequestApiError", {
        content:
          "There was some problem in raising service request. Please try again later.",
        headerText: "New Service Request",
      });
    }
  }

  getchildSrId = (stage: any) => {
    const { childSrList } = this.state;
    const childSr = childSrList.find(
      (child: any) =>
        child.RequestType === flow.find((f) => f.Stage === stage)?.RequestType
    );
    if (childSr?.is_digilocker_flow && !localStorage.getItem("rejectFlow")) {
      localStorage.setItem("digieResubmit", "Yes");
    }
    if (childSr) {
      return childSr.RequestId;
    } else {
      return null;
    }
  };
  
   getCKYCId =()=>{
    let childSr  = this.state.childSrList.find((x: any) => {if(x.RequestType === "CKYC Update") return x});
    return childSr? childSr.RequestId : "";
  }
  CurrentForm: any = () => {

    const { userData, srId, childSrList, currentFlow, paymentStatus }: any =
      this.state;
    const { onSubmit, showFooter, enableSubmit, setBtnText, stage } =
      this.props;
    const payStatus: any = localStorage.getItem("paymentReponse");
    const payStatus1: any = JSON.parse(payStatus);
    switch (stage.currentStage) {
      case 1:
        return (
          <ProfileForm
            next={this.nextStage}
            funcData={this.props}
            currentFlow={currentFlow}
            userData={userData}
            srId={srId}
            loader={this.props.loader}
            setLoader={this.props.setLoader}
          />
        );
      case 2:
        return (
          <AddressModification
            onSubmit={onSubmit}
            next={this.nextStage}
            childSr={true}
            srId={srId}
            getChildSr={this.getchildSrId}
            loader={this.props.loader}
            setLoader={this.props.setLoader}
            ckycStatus={
              childSrList.find((x: any) => x.RequestType === "CKYC Update")
                ? true
                : false
            }
            ckycId ={this.getCKYCId()}
          />
        );
      case 3:
        return (
          <Bank
            onSubmit={onSubmit}
            next={this.nextStage}
            childSr={true}
            showFooter={showFooter}
            userData={userData}
            srId={srId}
            getChildSr={this.getchildSrId}
            loader={this.props.loader}
            setLoader={this.props.setLoader}
          />
        );
      case 4:
        return (
          <CKYCUpdate
            onSubmit={onSubmit}
            enableSubmit={enableSubmit}
            next={this.nextStage}
            childSr={true}
            srId={srId}
            childSrList={childSrList}
            showFooter={showFooter}
            loader={this.props.loader}
            setLoader={this.props.setLoader}
          />
        );
      case 5:
        return (
          <VerficationStage
            onSubmit={onSubmit}
            next={this.nextStage}
            childSr={true}
            srId={srId}
            childSrList={childSrList}
            loader={this.props.loader}
            setLoader={this.props.setLoader}
          />
        );
      case 6:
        return (
          <AccountPayment
            onSubmit={onSubmit}
            enableSubmit={enableSubmit}
            next={this.nextStage}
            childSr={true}
            srId={srId}
            childSrList={childSrList}
            showFooter={showFooter}
            paymentStatus={payStatus1 ? payStatus1 : null}
            loader={this.props.loader}
            setLoader={this.props.setLoader}
          />
        );
      default:
        break;
    }
    this.props.setLoader(false);
  };

  render() {
    const { loader } = this.props;
    const { currentFlow } = this.state;
    return (
      // <div
      //   style={{
      //     textAlign: "center",
      //     paddingTop: "50px",
      //     paddingBottom: "50px",
      //   }}
      // >
      //   <Loader size={50} color="blue"></Loader>
      // </div>
      <>{currentFlow.length > 0 && <this.CurrentForm />}</>
    );
  }
}

export default AccReactivateCont;